// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d855a71b","744":"a2579712","801":"20ec1ad0"}[chunkId] + ".chunk.js";
};